<template>
  <div v-if="event">
    <!-- month view -->
    <div
      class="month-event-tx"
      v-if="view === 'month' && event.type === 'month'"
    >
      <div>
        <div v-for="(time, index) in event.hours" :key="index">
          {{ time }}
        </div>
        <div class="is-avail">{{ event.appointments }} תורים</div>
      </div>
    </div>

    <!-- week hover view -->
    <div v-if="view === 'week' && event.type === 'appointment'">
      <div
        v-if="event.type === 'appointment'"
        v-show="selectedEventHover && selectedEventHover._eid === event._eid"
        class="cal-hover-info tx--black"
      >
        <div class="cal-hover-info-in">
          <h2 class="title--32">
            {{ getDate(event.start) }} {{ getTime(event.start) }}
            <div>{{ event.patientName }}</div>
          </h2>
          <div class="cal-hover-info-list">
            <div class="flex">
              <div>סוג התור</div>
              <div>{{ event.appointmentName }}</div>
            </div>
            <div class="flex">
              <div>ת.ז.</div>
              <div>{{ event.patientPassport }}</div>
            </div>
            <div class="flex">
              <div>תאריך לידה</div>
              <div>{{ getDate(event.patientBirthDate) }}</div>
            </div>
            <div class="flex">
              <div>טלפון נייד</div>
              <div>{{ event.patientPhone }}</div>
            </div>
            <div v-if="event.scheduled_by && getScheduledBy()" class="flex">
              <div>מקור שיבוץ</div>
              <div class="flex flex--start">
                <img
                  :src="getScheduledBy().image"
                  :alt="getScheduledBy().text"
                />
                {{ getScheduledBy().text }}
              </div>
            </div>
          </div>

          <div
            class="cal-hover-info-note over--hide"
            v-if="event.notes.length > 0"
          >
            <div class="text text--20">
              {{ event.notes }}
            </div>
            <img
              v-if="
                event.arrival_approval &&
                  event.arrival_approval.includes('approved')
              "
              src="/assets/img/svg/ok-green.svg"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- private block event -->
    <div
      class="is_private-tx bold flex flex--start"
      v-if="
        (view === 'week' || view === 'day') &&
          event.type === 'block' &&
          event.is_private
      "
    >
      <img src="/assets/img/svg/blocked.svg" />
      חסוי
    </div>

    <!-- week / day view -->
    <div
      v-if="
        (view === 'day' || view === 'week') &&
          viewBySelect !== 'list' &&
          event.type === 'appointment'
      "
      class="flex flex--top cal-day-info"
    >
      <!-- :class="view === 'week' ? 'cal-week-inline' : 'cal-day-info'" -->
      <h2>{{ getTime(event.start) }}</h2>
      <div
        v-if="event.type === 'appointment'"
        class="cal-day-info-list is--fit flex flex--start"
      >
        <div class="flex line-clamp">
          {{ event.patientName }} {{ event.patientPassport }} |
          {{ event.description }} {{ event.patientPhone }}
          <span v-if="event.notes">| {{ event.notes }}</span>
          <span v-if="event.payment_status">| סטטוס תשלום: שולם</span>
        </div>
      </div>
      <div class="cal-day-info-left flex flex--top">
        <div
          v-if="getBubbleStatus()"
          class="cal-day-info-left-ic status-bubble"
          :style="getBubbleStatus().color"
        >
          <img
            :src="getBubbleStatus().icon"
            :style="getBubbleStatus().iconStyle"
          />
          <span>{{ getBubbleStatus().text }}</span>
        </div>
        <div
          v-if="event.scheduled_by && getScheduledBy()"
          class="cal-day-info-left-ic"
        >
          <img :src="getScheduledBy().image" :alt="getScheduledBy().text" />
        </div>
        <!-- DOTS ELEMENT -->
        <div class="nav-dots-wrapper" @click="e => toggleMenu(true, e)">
          <button class="nav-dots flex flex--end">
            <span class="nav-dot"></span>
          </button>
        </div>
        <div
          class="open-nav-dots"
          v-if="currentOpen === event.id"
          v-click-outside="e => toggleMenu(false, e)"
        >
          <div
            class="row flex flex--end block_action edit-btn"
            @click="$router.push(`/app-edit/${event.id}`)"
          >
            <span class="edit-btn">&nbsp; עריכת תור</span
            ><img
              class="scheduling-svg edit-btn"
              src="/assets/img/svg/clock.svg"
            />
          </div>
          <div
            v-if="!isAppointmentPassed"
            class="row flex flex--end block_action resched-btn"
            @click="cancelPop"
          >
            <span class="resched-btn">ביטול תור</span><TrashSvg />
          </div>
          <div class="row flex flex--end block_action doc-btn" @click="addDoc">
            <span class="doc-btn">&nbsp; הוספת מסמכים</span>
            <div class="img-container">
              <img
                class="scheduling-svg"
                src="/assets/img/svg/file-doc-blue.svg"
              />
            </div>
          </div>
          <div
            v-if="showCellosignPage"
            class="row flex flex--end block_action cellosign-btn"
            @click="$router.push(`/cellosign/?appId=${event.id}`)"
          >
            <span class="cellosign-btn">&nbsp; טפסי הסכמה</span
            ><img
              class="scheduling-svg cellosign-btn"
              src="/assets/img/svg/file-doc-blue.svg"
            />
          </div>
          <div
            id="sms-line"
            class="row flex flex--end block_action sms-btn"
            @click="sendSms"
          >
            <span id="sms-label" class="sms-btn">&nbsp; שליחת הודעה</span
            ><svg
              id="sms-svg"
              class="sms-btn"
              fill="#324997"
              style="cursor: pointer;"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
              enable-background="new 0 0 52 52"
              xml:space="preserve"
            >
              <g class="sms-btn" id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                class="sms-btn"
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g class="sms-btn" id="SVGRepo_iconCarrier">
                <path
                  class="sms-btn"
                  d="M26,4C12.7,4,2.1,13.8,2.1,25.9c0,3.8,1.1,7.4,2.9,10.6c0.3,0.5,0.4,1.1,0.2,1.7l-3.1,8.5 c-0.3,0.8,0.5,1.5,1.3,1.3l8.6-3.3c0.5-0.2,1.1-0.1,1.7,0.2c3.6,2,7.9,3.2,12.5,3.2C39.3,48,50,38.2,50,26.1C49.9,13.8,39.2,4,26,4z M16.4,29.6c-0.3,0.5-0.6,1-1,1.3s-0.9,0.6-1.5,0.8c-0.5,0.2-1.1,0.2-1.7,0.2c-0.8,0-1.5-0.1-2.2-0.4c-0.7-0.3-1.4-0.7-1.9-1.3 L7.9,30c-0.1-0.1,0-0.3,0.2-0.5L9.7,28c0.2-0.2,0.4-0.2,0.5-0.1s0.2,0.3,0.2,0.3c0.2,0.3,0.5,0.5,0.8,0.7c0.5,0.3,1,0.3,1.6,0.2 c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.4-0.1-0.5-0.2-0.6c-0.2-0.2-0.5-0.4-0.9-0.5 s-0.8-0.3-1.3-0.4c-0.5-0.2-1-0.4-1.4-0.6c-0.5-0.3-0.8-0.7-1.1-1.1c-0.3-0.5-0.5-1.1-0.5-1.9c0-0.7,0.1-1.3,0.4-1.8 c0.3-0.5,0.6-0.9,1.1-1.2c0.4-0.3,0.9-0.6,1.5-0.7c1.2-0.3,2.4-0.3,3.6,0.1c0.6,0.2,1.2,0.6,1.5,0.8l0.3,0.2 c0.2,0.1,0.1,0.4-0.1,0.6l-1.5,1.5c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.1-0.3-0.3-0.4-0.3c-0.5-0.3-1.2-0.4-1.8-0.3 c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.3,0.1,0.4,0.2,0.5c0.2,0.2,0.5,0.3,0.9,0.5 c0.4,0.1,0.8,0.3,1.3,0.4c0.5,0.2,1,0.4,1.4,0.6c0.5,0.3,0.8,0.7,1.1,1.1c0.3,0.5,0.5,1.1,0.5,1.9C16.8,28.5,16.7,29.1,16.4,29.6z M33,31c0,0.6-0.5,1-1.1,1h-1c-0.6,0-0.9-0.4-0.9-1v-5.9c0-0.6-0.8-0.7-1-0.2l-1.7,4.5c-0.1,0.4-0.5,0.6-0.9,0.6h-0.7 c-0.4,0-0.8-0.3-0.9-0.6L23,24.9c-0.2-0.5-1-0.4-1,0.2V31c0,0.6-0.5,1-1.1,1h-1c-0.6,0-0.9-0.4-0.9-1V20c0-0.6,0.4-1,0.9-1h2.6 c0.4,0,0.8,0.3,0.9,0.6l2,5.2c0.2,0.4,0.8,0.4,0.9,0l2-5.2c0.1-0.4,0.5-0.6,0.9-0.6h2.7c0.6,0,1.1,0.4,1.1,1V31z M43.5,29.7 c-0.3,0.5-0.6,1-1.1,1.3c-0.4,0.3-0.9,0.6-1.5,0.8S39.8,32,39.2,32c-0.8,0-1.5-0.1-2.2-0.4c-0.7-0.3-1.4-0.7-1.9-1.3l-0.2-0.2 c-0.1-0.1,0-0.3,0.2-0.5l1.6-1.5c0.2-0.2,0.4-0.2,0.5-0.1s0.2,0.3,0.2,0.3c0.2,0.3,0.5,0.5,0.8,0.7c0.5,0.3,1.1,0.3,1.6,0.2 c0.2-0.1,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.2,0.3-0.3s0.1-0.3,0.1-0.4c0-0.4-0.1-0.5-0.2-0.6c-0.2-0.2-0.5-0.4-0.9-0.5 s-0.8-0.3-1.3-0.4c-0.5-0.2-1-0.4-1.4-0.6c-0.5-0.3-0.9-0.7-1.2-1.1c-0.3-0.5-0.5-1.1-0.5-1.9c0-0.7,0.1-1.3,0.4-1.8 c0.3-0.5,0.6-0.9,1.1-1.2c0.4-0.3,1-0.6,1.5-0.7c1.2-0.3,2.4-0.3,3.6,0.1c0.6,0.2,1.2,0.6,1.5,0.9l0.3,0.3c0.2,0.1,0.1,0.4-0.1,0.6 L42,22.9c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.1-0.3-0.3-0.4-0.3c-0.5-0.3-1.2-0.4-1.8-0.3c-0.2,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.4,0.2,0.5c0.2,0.2,0.5,0.3,0.9,0.5c0.4,0.1,0.8,0.3,1.3,0.4 c0.5,0.2,1,0.4,1.4,0.6c0.5,0.3,0.8,0.7,1.2,1.1c0.3,0.5,0.5,1.1,0.5,1.9C43.9,28.5,43.8,29.2,43.5,29.7z"
                ></path>
              </g>
            </svg>
          </div>
          <div
            v-if="isAppointmentPassed"
            id="arrived-line"
            class="row flex flex--end block_action arrived-btn"
            @click="reportArrival"
          >
            <span v-if="!isPatientArrived" class="arrived-btn"
              >&nbsp; דווח הגעה לתור</span
            >
            <span v-else class="arrived-btn">&nbsp; דווח אי הגעה לתור</span>
            <img src="/assets/img/svg/ic-pen-blue.svg" />
          </div>
          <a
            id="arrived-line"
            class="row flex flex--end block_action arrived-btn"
            href="javascript:void(0);"
            @click="openWhatsapp(event.patientPhone)"
          >
            <span class="arrived-btn">&nbsp; שליחת וואטסאפ</span>
            <img src="/assets/img/svg/wts-blue.svg" />
          </a>
          <div
            class="row flex flex--end block_action queue-call-btn"
            @click="sendQueueCall"
          >
            <span class="queue-call-btn">&nbsp; קריאה לחדר</span>
            <img
              class="scheduling-svg queue-call-btn"
              src="/assets/img/svg/bell-blue.svg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTime, getDate, isDatePassed } from "../../../utilities/dates.js";
import TrashSvg from "../../../assets/img/svg/trash.svg";
import CancelPop from "../../Popups/CancelApp.vue";
import Error from "../../Popups/Error.vue";
import SMSToPatient from "../../Popups/SMSToPatient.vue";
import ClickOutside from "vue-click-outside";
import Whatsapp from "../../Popups/Whatsapp.vue";
import AddDocuments from "@/components/Popups/AddDocuments";
import { sendQueueCall } from "@/api/api-quatro";
import Success from "../../Popups/Success.vue";
import { mapGetters } from "vuex";

export default {
  name: "AppViewEvent",
  props: {
    event: {
      required: true
    },
    viewBySelect: {
      required: true,
      type: String
    },
    view: {
      required: true,
      type: String
    },
    selectedEventHover: {
      required: true
    },
    currentOpen: {
      required: true
    }
  },
  emits: ["updateCurrentOpen"],
  components: {
    TrashSvg
  },
  data() {
    return {
      isMenuOpen: false
    };
  },
  computed: {
    ...mapGetters(["showCellosignPage"]),
    bubbleStatus() {
      if (this.isPatientArrived) {
        return {
          text: "דווח הגעה",
          color: "background-color: #01a87a;"
        };
      } else if (
        this.event.arrival_approval &&
        this.event.arrival_approval.includes("approved")
      ) {
        return {
          text: "אושר הגעה",
          color: "background-color: #5581bd;"
        };
      }
      return null;
    },
    isAppointmentPassed() {
      return this.isDatePassed(this.event.start);
    },
    isPatientArrived() {
      return (
        this.event.status &&
        (this.event.status == "arrived" || this.event.status == "הגיע")
      );
    }
  },
  methods: {
    getDate,
    getTime,
    isDatePassed,
    getScheduledBy() {
      return this.$store.getters["getAppScheduledBy"](
        this.event.scheduled_by,
        false
      );
    },
    getBubbleStatus() {
      return this.$store.getters["getAppBubbleStatus"](
        this.event.status,
        this.event.arrival_approval
      );
    },
    toggleMenu(newState = false, event) {
      const classes = event.target.className;
      if (!newState && classes.includes("nav-dots flex flex--end")) return;
      this.$emit("updateCurrentOpen", newState ? this.event.id : "");
    },
    sendSms() {
      this.$modal.show(SMSToPatient, {
        patientName: this.event.patientName,
        patientPassport: this.event.patientPassport,
        surgId: this.event.id,
        eventType: "appointment"
      });
      this.$emit("updateCurrentOpen", "");
    },
    cancelPop() {
      this.$modal.show(
        CancelPop,
        { appointment_id: this.event.id, appDate: this.event.start.toString() },
        { clickToClose: true }
      );
      this.$emit("updateCurrentOpen", "");
    },
    addDoc(e) {
      this.toggleMenu(false, e);
      this.$modal.show(AddDocuments, { directUpload: this.event });
    },
    async reportArrival() {
      try {
        await this.$API.statusArrival(this.event.id, !this.isPatientArrived);
        this.$root.$emit("refreshBlock");
        this.$emit("updateCurrentOpen", "");
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    openWhatsapp(phone) {
      this.$modal.show(Whatsapp, { patientPhone: phone });
    },
    sendQueueCall() {
      const action = sendQueueCall(
        this.event.patientPhone,
        this.event.patientName
      );
      this.$emit("updateCurrentOpen", "");
      this.$modal.show(Success, {
        title: "הקריאה לחדר נשלחה בהצלחה",
        loadingTitle: "שולח קריאה לחדר...",
        action
      });
    }
  },

  directives: {
    ClickOutside
  }
};
</script>

<style scoped>
.nav-dots-wrapper {
  margin-left: 12px;
}

.nav-dots-wrapper button {
  margin-top: 3px;
}
</style>
